<template>
  <div class="skip-trial-modal">
    <CNuxtImg
      src="/images/img_skip_discount.webp"
      class="skip-trial-modal__img"
      min-height="132px"
      alt="skip discount"
    />
    <h2 class="skip-trial-modal__title">
      {{ $t('oldTranslations.modals.skipTrial.title') }}
    </h2>
    <p class="skip-trial-modal__text" v-html="$t('oldTranslations.modals.skipTrial.text_1')" />
    <p class="skip-trial-modal__text" v-html="$t('oldTranslations.modals.skipTrial.text_2')" />
    <base-button
      type="red"
      with-shadow
      rounded="full"
      class="skip-trial-modal__cta"
      @click="handleContinue"
    >
      {{ $t('oldTranslations.modals.skipTrial.cta') }}
    </base-button>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['action']);
const { toggleComponent } = useModals();
const { $db } = useNuxtApp();
function handleContinue() {
  toggleComponent();
  $db.setItem('trial_skipped', true);
  emit('action');
}
</script>

<style lang="scss" scoped>
.skip-trial-modal {
  padding: 30px 24px 48px;
  background: #fff;
  border-radius: 16px;
  max-width: 375px;
  width: calc(100% - 64px);

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  &__img {
    width: 79%;
    margin: 0 auto 10px;
    display: block;
  }

  &__title {
    text-align: center;
    font-family: $primary-fonts;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 135%; /* 32.4px */
    margin-bottom: 24px;
  }

  &__text {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */
    margin-bottom: 16px;

    & :deep(.bold) {
      font-weight: 600;
    }
  }

  &__cta {
    margin-top: 32px;
  }
}
</style>
